import { Component, ChangeDetectionStrategy, Inject, ViewChild, TemplateRef } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

import {
  startOfDay,
  endOfDay,
  subDays,
  addDays,
  endOfMonth,
  isSameDay,
  isSameMonth,
  addHours
} from 'date-fns';

import { Subject, BehaviorSubject } from 'rxjs';

import {
  CalendarEvent,
  CalendarEventAction,
  CalendarEventTimesChangedEvent
} from 'angular-calendar';
import { AppComponentClass } from '../../shared/service/AppComponent.class';
import { Calendar, CalendarForm } from '../model/model.class';
import { Router } from '@angular/router';
import { CalendarService } from '../calendar.service';
import { MatSnackBar, MatDatepickerInputEvent } from '@angular/material';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { Option } from '../../shared/model/model.class';
import { HttpClient } from '@angular/common/http';
import { APIURL } from '../../app-routing.module';
import { Theme } from '../../shared/service/AutoTheme';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

const colors: any = {
  green: {
    primary: '#0ca12e',
    secondary: '#0ca12e'
  },
  yellow: {
    primary: '#D88E08',
    secondary: '#D88E08'
  },
  blue: {
    primary: '#3a87ad',
    secondary: '#3a87ad'
  }
};

@Component({
  selector: 'app-mycalendar',
  templateUrl: './mycalendar.component.html',
  styleUrls: ['./mycalendar.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MycalendarComponent extends AppComponentClass<Calendar, CalendarForm> {

  public form:FormGroup;
  events: CalendarEvent[] = [];
  list1  = false;
  loading = true;
  protected calstatus=new BehaviorSubject<boolean>(false);
  public calander = this.calstatus.asObservable();
  public activeApproveBtn:boolean = false;
  pending_request:any=0;
  pending_approve:any=0;
  public currentRequestStaus:any=0;
  public cal_list:Option[];
  public cal_id:string = "";
  public startlimit:any;
  public endlimit:any;
  public address : string;
  timezonelist: any;
  public timezone:string=sessionStorage.getItem("timezone");
  public pendingUserList:any;
  public showloader:boolean=false;
  public getAllRequest:any[];
  constructor(public dialog:MatDialog,public edata: CalendarService, protected router: Router, protected fb: FormBuilder, protected msg: MatSnackBar, private modal: NgbModal,protected http:HttpClient,public theme:Theme)
  {
    super(edata, router, fb , msg);
    this.theme.showMenu(true);
    this.theme.ChangeEvent(0);
  }

  actions: CalendarEventAction[] = [

  ];


  ngOnInit() {
    this.loading = true;   
    sessionStorage.setItem('pagetrack', 'calendar');
     this.address = sessionStorage.getItem('current_address');
     if(sessionStorage.type==4){
        this.activeApproveBtn=true;
     }
    
    this.edata.getCalandarService({leadaddress:this.address, timezone:this.timezone}).subscribe(res => {
      console.log("calendar service");
      console.log(res);
      if(res!=null)
      {
        this.cdata= new CalendarForm(res[0]);
        this.events = this.cdata.MakeEvent(res, this.actions, colors.green);
        console.log("calendar event");
        console.log(this.events);
        this.edata.getCalendarList().subscribe(res1=>{
          console.log("calendar list");
          console.log(res1);
          this.cal_list=res1;

          this.edata.getAuthToken().subscribe(rs=>{
            console.log("Auth token my calendar");
            console.log(rs);
            if(rs!=null)
            {
              if(rs[0].access_token && rs[0].status==3)
              {
                this.form=this.cdata.makeform(this.fb);
                console.log("calling now for calendar_id");
                this.calstatus.next(true);
                console.log(rs);
                this.cdata.calendar_id=rs[0].calendar_id;
                this.form.controls['calendar_id'].setValue(rs[0].calendar_id);
                this.cdata.startlimit=rs[0].startlimit;
                this.form.controls['startlimit'].setValue(rs[0].startlimit);
                this.startlimit = new FormControl((new Date(this.cdata.startlimit)).toISOString());
                this.cdata.endlimit=rs[0].endlimit;
                this.form.controls['endlimit'].setValue(rs[0].endlimit);
                this.endlimit = new FormControl((new Date(this.cdata.endlimit)).toISOString());
                this.cal_id=rs[0].calendar_id;
                this.loading = false;
              }
              else
              {
                //this.router.navigate ( [ '/calendar/googlelogin' ] );
              }
            }
            else
            {
              //this.cdata.calendar_id="";
              //this.router.navigate ( [ '/calendar/googlelogin' ] );
            }
              
            
          });
          
        },err=>{
          console.log(err);
          //this.router.navigate ( [ '/calendar/googlelogin' ] );
        });

        
      }
      else
      {
        //this.router.navigate ( [ '/calendar/googlelogin' ] );
      }
      
      console.log("working");
      
    });

    this.edata.GetTimezoneList().subscribe(res=>{
      this.timezonelist=res;
      console.log(res);
    });
    
  }

  onStartChange(e: MatDatepickerInputEvent<Date>)
  { 
    if(e.value)
    {
      var tmp = new Date(e.value);
      var mth="";
      var day="";
      if(tmp.getDate()<9)
        day="0"+tmp.getDate();
      else
        day=tmp.getDate().toString();
      if(tmp.getMonth()<9)
        mth="0"+(tmp.getMonth()+1);
      else
        mth=(tmp.getMonth()+1).toString();
      this.cdata.startlimit=tmp.getFullYear()+"-"+mth+"-"+day;
      console.log(e);
    }
    else
    {
      alert("Please select any date");
    }
  }

  onEndChange(e: MatDatepickerInputEvent<Date>)
  {
    if(e.value)
    {
      var tmp = new Date(e.value);  
      var mth="";
      var day="";
      if(tmp.getDate()<9)
        day="0"+tmp.getDate();
      else
        day=tmp.getDate().toString();
      if(tmp.getMonth()<9)
        mth="0"+(tmp.getMonth()+1);
      else
        mth=(tmp.getMonth()+1).toString();   
      this.cdata.endlimit=tmp.getFullYear()+"-"+mth+"-"+day;
      console.log(e);
    }
    else
    {
      alert("Please select any date");
    }
  }
  
 

  onSubmit()
  {
    console.log("trying to submit form");
    console.log(this.cdata);
    console.log(this.cdata.startlimit);
    console.log(this.cdata.endlimit);

    var tmp = new Date(this.cdata.startlimit);
    var mth="";
    var day="";
    if(tmp.getDate()<9)
      day="0"+tmp.getDate();
    else
      day=tmp.getDate().toString();
    if(tmp.getMonth()<9)
      mth="0"+(tmp.getMonth()+1);
    else
      mth=(tmp.getMonth()+1).toString();
    this.cdata.startlimit=tmp.getFullYear()+"-"+mth+"-"+day;
    console.log(this.cdata.startlimit);

    var tmp = new Date(this.cdata.endlimit);  
    var mth="";
    var day="";
    if(tmp.getDate()<9)
      day="0"+tmp.getDate();
    else
      day=tmp.getDate().toString();
    if(tmp.getMonth()<9)
      mth="0"+(tmp.getMonth()+1);
    else
      mth=(tmp.getMonth()+1).toString();   
    this.cdata.endlimit=tmp.getFullYear()+"-"+mth+"-"+day;
    console.log(this.cdata.endlimit);

    if(this.cdata.startlimit=='NaN-NaN-NaN' || this.cdata.endlimit=='NaN-NaN-NaN')
    {
      alert("Please select any date");
    }
    else
    {
      if(confirm("Are you sure you want to re-sync your calendar?"))
      {
        this.edata.updateMyCalender({calendar_id: this.form.get("calendar_id").value, startlimit: this.cdata.startlimit, endlimit: this.cdata.endlimit, status:2}, "updatecalid").subscribe(res=>{
        console.log(res);
          this.router.navigate ( [ '/calendar/googlelogin' ] );
        });
      }
    }
  }

  deleteCalendar()
  {
    if(confirm("Are you sure you want to delete current calendar access?"))
    {
      this.edata.updateMyCalender({status: 4}, "deletecal").subscribe(res=>{
        console.log(res);
        this.router.navigate ( [ '/calendar/googlelogin' ] );
      });
    }
  }

  @ViewChild('modalContent') modalContent: TemplateRef<any>;

  view: string = 'week';

  viewDate: Date = new Date();

  modalData: {
    action: string;
    event: CalendarEvent;
  };

  refresh: Subject<any> = new Subject();
  

 loadNextEvents(e: Date)
  {
    this.activeDayIsOpen = false;
    var currentdate = e;
    var today = new Date();
    var nextWeek = new Date(today.getTime() + 7 * 24 * 60 * 60 * 1000);
    if(currentdate.getTime() >= nextWeek.getTime())
    {
      this.loading = true;
      this.calstatus.next(false);
      sessionStorage.setItem('pagetrack', 'calendar');
      this.address = sessionStorage.getItem('current_address');
      console.log(this.address);
      var mth="";
      var day="";
      if(currentdate.getDate()<9)
        day="0"+currentdate.getDate();
      else
        day=currentdate.getDate().toString();
      if(currentdate.getMonth()<9)
        mth="0"+(currentdate.getMonth()+1);
      else
        mth=(currentdate.getMonth()+1).toString();   
      var currentweekdate =currentdate.getFullYear()+"-"+mth+"-"+day;
      this.edata.getCalandarService({leadaddress:this.address,endweekdate:currentweekdate}).subscribe(res => {
        console.log(res);
        if(res!=null)
        {
          this.events = this.cdata.MakeEvent(res, this.actions, colors.green);
          this.calstatus.next(true);
        }
        else
        {
          //this.router.navigate ( [ '/calendar/googlelogin' ] );
        }
        this.loading = false;
        console.log("working");
        
      });
    }
  }


   activeDayIsOpen: boolean = true;

   dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
     if (isSameMonth(date, this.viewDate)) {
       this.viewDate = date;
       if (
         (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
         events.length === 0
       ) {
         this.activeDayIsOpen = false;
       } else {
         this.activeDayIsOpen = true;
       }
     }
   }


  ChangeCalendar(tztype:string)
  {
    console.log("Timezone", tztype);
    this.edata.getCalandarService({leadaddress:this.address, timezone:tztype}).subscribe(res => {
      console.log("calendar service");
      console.log(res);
      if(res!=null)
      {
        this.cdata= new CalendarForm(res[0]);
        this.events = this.cdata.MakeEvent(res, this.actions, colors.green);
        console.log("calendar event");
        console.log(this.events);
        this.edata.getCalendarList().subscribe(res1=>{
          console.log("calendar list");
          console.log(res1);
          this.cal_list=res1;

          this.edata.getAuthToken().subscribe(rs=>{
            console.log("Auth token my calendar");
            console.log(rs);
            if(rs!=null)
            {
              if(rs[0].access_token && rs[0].status==3)
              {
                this.form=this.cdata.makeform(this.fb);
                console.log("calling now for calendar_id");
                this.calstatus.next(true);
                console.log(rs);
                this.cdata.calendar_id=rs[0].calendar_id;
                this.form.controls['calendar_id'].setValue(rs[0].calendar_id);
                this.cdata.startlimit=rs[0].startlimit;
                this.form.controls['startlimit'].setValue(rs[0].startlimit);
                this.startlimit = new FormControl((new Date(this.cdata.startlimit)).toISOString());
                this.cdata.endlimit=rs[0].endlimit;
                this.form.controls['endlimit'].setValue(rs[0].endlimit);
                this.endlimit = new FormControl((new Date(this.cdata.endlimit)).toISOString());
                this.cal_id=rs[0].calendar_id;
                this.loading = false;
              }
              else
              {
                //this.router.navigate ( [ '/calendar/googlelogin' ] );
              }
            }
            else
            {
              //this.router.navigate ( [ '/calendar/googlelogin' ] );
            }
              
            
          });
          
        },err=>{
          console.log(err);
          //this.router.navigate ( [ '/calendar/googlelogin' ] );
        });

        
      }
      else
      {
        //this.router.navigate ( [ '/calendar/googlelogin' ] );
      }
      
      console.log("working");
      
    });
  }
  

}
